import { clsx } from 'clsx';

import { MyNumber } from '@/api/types';
import { RegionBadge } from '@/components/shared/RegionBadge/RegionBadge.tsx';

import cn from './styles.module.sass';

interface IStatusBadgeProps {
    status: MyNumber['status'];
}

export const StatusBadge = ({ status }: IStatusBadgeProps) => {
    let statusName: string;

    switch (status) {
        case 'active':
            statusName = 'Активен';
            break;
        case 'inactive':
            statusName = 'Неактивен';
            break;
        case 'delivery':
            statusName = 'Доставка';
            break;
        case 'disabled':
            statusName = 'Отключен';
            break;
    }

    return (
        <RegionBadge
            region={statusName}
            className={clsx(
                status === 'active' && cn.active,
                status === 'inactive' && cn.inactive,
                status === 'delivery' && cn.delivery,
                status === 'disabled' && cn.disabled
            )}
        />
    );
};
